<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.name"
              placeholder="请输入名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.status"
              placeholder="状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @del="delFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
        @publish="publishFun(arguments)"
        @back="backFun(arguments)"
      />
    </div>

    <!-- 新增 修改-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 查询-->
    <view-dialog
      :data-id="id"
      :event-type="'view'"
      :dialog-title="dialogViewTitle"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 新增 修改
import addEditViewDialog from './components/addEditViewDialog'
// 查询
import viewDialog from './components/viewDialog'
// API
import { loadSalaryActivityPerformanceBillListDataApi, exportSalaryActivityPerformanceBillListDataApi, deleteSalaryActivityPerformanceBillApi, publishSalaryActivityPerformanceBillApi, backSalaryActivityPerformanceBillApi } from '@/api/v2/salaryActivityPerformanceBill'

export default {
  name: 'SalaryActivityPerformanceBillView',
  components: {
    CustomTable2,
    TableOperation2,
    addEditViewDialog,
    viewDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'salary_activity_performance_bill_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['salary_activity_performance_bill_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['salary_activity_performance_bill_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['salary_activity_performance_bill_del'],
            prop: 'del',
            label: '作废',
            method: 'del'
          },
          {
            permissionSigns: ['salary_activity_performance_bill_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['salary_activity_performance_bill_publish'],
            prop: 'publish',
            label: '发布',
            method: 'publish'
          },
          {
            permissionSigns: ['salary_activity_performance_bill_back'],
            prop: 'back',
            label: '撤回',
            method: 'back'
          },
          {
            permissionSigns: ['salary_activity_performance_bill_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          name: '',
          status: ''
        }
      },
      id: null,
      eventType: '',
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',
      dialogViewVisible: false,
      dialogViewTitle: '',
      statusOptions: [{label: '制单', data: 1},{label: '发布', data: 2}]
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'name', label: '名称', filterColumn: 'name', width: 260 },
      { prop: 'infoCount', label: '绩效条数', filterColumn: 'info_count', width: 120 },
      { prop: 'performanceTotal', label: '绩效总金额', filterColumn: 'performance_total', width: 160 },
      { prop: 'deductTotal', label: '扣除总金额', filterColumn: 'deduct_total', width: 160 },
      { prop: 'realPerformanceTotal', label: '实发绩效总金额', filterColumn: 'real_performance_total', width: 160 },
      { prop: 'remark', label: '备注', width: 280 },
      { prop: 'statusValue', label: '状态', filterColumn: 'status', filterValue: 'status', filterArray: [{ label: '制单', value: 1 }, { label: '发布', value: 2 }], width: 120 },
      { prop: 'creatorName', filterColumn: 'creator_name', label: '创建人', width: 120 },
      { prop: 'createTime', filterColumn: 'create_time', label: '创建时间', width: 150, isBetween: true },
      { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 120 },
      { prop: 'operationTime', filterColumn: 'operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadSalaryActivityPerformanceBillListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        this.handleData(data.list || [])
        this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    //新增
    addFun () {
      let _this = this;
      _this.eventType = 'add'
      _this.dialogAddEditTitle = '新增活动报告人员绩效发放管理'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 修改
    editFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的活动报告人员绩效发放管理', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogAddEditTitle = '修改活动报告人员绩效发放管理'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 查看
    viewFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的活动报告人员绩效发放管理', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'view'
      _this.dialogViewTitle = '查看活动报告人员绩效发放管理'
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 作废
    delFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.$confirm('是否确定作废该活动报告人员绩效发放管理？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        deleteSalaryActivityPerformanceBillApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '作废成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 发布
    publishFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.$confirm('是否确定发布该活动报告人员绩效发放管理？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        publishSalaryActivityPerformanceBillApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '发布成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 撤回
    backFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.$confirm('是否确定撤回该活动报告人员绩效发放管理？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        backSalaryActivityPerformanceBillApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '撤回成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportSalaryActivityPerformanceBillListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
